// Route prefix for each IELTS mock test. Mock 1 keeps its original
// /quiz/<module> URLs; later mocks live under their own prefix.
const IELTS_MOCK_PREFIX = {
  1: "/quiz",
  2: "/quiz/ielts-mock2",
  3: "/quiz/ielts-mock3",
  4: "/quiz/ielts-mock4",
  5: "/quiz/ielts-mock5",
  6: "/quiz/ielts-mock6",
  7: "/quiz/ielts-mock7",
};

// ieltsPath(3, "reading", "/intro") -> "/quiz/ielts-mock3/reading/intro"
export const ieltsPath = (mock, module, suffix = "") =>
  `${IELTS_MOCK_PREFIX[mock] || IELTS_MOCK_PREFIX[1]}/${module}${suffix}`;
